import React from 'react';
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router';
import EmbedProgramByFilename from '../pages/CamProgramming/embed/EmbedProgramByFilename';
import EmbedProgramIssueLogPage from '../pages/CamProgramming/embed/EmbedProgramIssueLogPage';
import EmbedProgramProgrammingByFilename from '../pages/CamProgramming/embed/EmbedProgramProgrammingByFilename';
import EmbedProgrammingPage from '../pages/CamProgramming/embed/EmbedProgrammingPage';

const ProgramById: React.FC = () => {
	const { programId = '' } = useParams<{ programId: string }>();
	return <EmbedProgramIssueLogPage programId={programId} />;
};

/**
 * The review phase used to be part of the URL. It is derived from the
 * program's reviews and the signed-in user now, so the phase-addressed paths
 * survive only to drop it — an older embedding host still lands somewhere.
 */
const DropPhase: React.FC = () => {
	const { search } = useLocation();
	return <Navigate to={`/embed/program${search}`} replace />;
};

const DropPhaseById: React.FC = () => {
	const { programId = '' } = useParams<{ programId: string }>();
	return <Navigate to={`/embed/programs/${programId}`} replace />;
};

const ProgrammingById: React.FC = () => {
	const { programId = '' } = useParams<{ programId: string }>();
	return <EmbedProgrammingPage programId={programId} />;
};

const EmbedRoutes = () => (
	<Routes>
		{/* Filename-addressed entry point. The document name travels as a query
		    parameter because Fusion document names contain spaces, dots and
		    slashes that do not survive a path segment. */}
		<Route path="program" element={<EmbedProgramByFilename />} />
		<Route path="programming" element={<EmbedProgramProgrammingByFilename />} />
		<Route path="programs/:programId" element={<ProgramById />} />
		<Route path="programs/:programId/programming" element={<ProgrammingById />} />

		<Route path="review" element={<DropPhase />} />
		<Route path="secondary-review" element={<DropPhase />} />
		<Route path="programs/:programId/review" element={<DropPhaseById />} />
		<Route
			path="programs/:programId/secondary-review"
			element={<DropPhaseById />}
		/>
	</Routes>
);

export default EmbedRoutes;
